import actionTypes from './actionTypes';
import cafeTablesActionTypes from '../cafeTables/actionTypes';
import { action, generateErrorAction } from '../actions';
import API from '../../apis';
import { store } from '../configureStore';

export const autoGenerateReservationTimes = data => {
  const request = () => async dispatch => {
    dispatch(loading());

    try {
      const res = await API.reserveTimes.autoGenerateReserveTimes(data);
      return dispatch(success(res));
    } catch (err) {
      dispatch(
        generateErrorAction(err, {
          failure: actionTypes.AUTO_GENERATE_RESERVATION_TIMES_FAILED,
          reject: actionTypes.AUTO_GENERATE_RESERVATION_TIMES_REJECT,
        }),
      );
      throw err;
    }
  };

  function loading() {
    return action(actionTypes.AUTO_GENERATE_RESERVATION_TIMES_LOADING);
  }

  function success(res) {
    return action(actionTypes.AUTO_GENERATE_RESERVATION_TIMES_SUCCESS, res);
  }

  return request();
};

export const clearAutoGenerateForm = _ => {
  return dispatch => {
    dispatch(action(actionTypes.CLEAR_AUTO_GENERATE_RESERVATION_TIMES));
    dispatch(action(cafeTablesActionTypes.CLEAR_CAFE_TABLES_LIST_DATA));
  };
};

export const fetchAllReservationDays = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.reservations
        .fetchAllReservationDays(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_RESERVATION_DAYS_FAILED,
              reject: actionTypes.FETCH_RESERVATION_DAYS_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_RESERVATION_DAYS_LOADING);
  const success = res =>
    action(actionTypes.FETCH_RESERVATION_DAYS_SUCCESS, res);

  return request();
};

export const fetchReservationDayDetails = id => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.reservations
        .fetchReservationDayDetails(id)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_RESERVATION_DAY_DETAILS_FAILED,
              reject: actionTypes.FETCH_RESERVATION_DAY_DETAILS_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () =>
    action(actionTypes.FETCH_RESERVATION_DAY_DETAILS_LOADING);
  const success = res =>
    action(actionTypes.FETCH_RESERVATION_DAY_DETAILS_SUCCESS, res);

  return request();
};

export const fetchReservationHourDetails = id => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.reservations
        .fetchReservationHourDetails(id)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_RESERVATION_HOUR_DETAILS_FAILED,
              reject: actionTypes.FETCH_RESERVATION_HOUR_DETAILS_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () =>
    action(actionTypes.FETCH_RESERVATION_HOUR_DETAILS_LOADING);
  const success = res =>
    action(actionTypes.FETCH_RESERVATION_HOUR_DETAILS_SUCCESS, res);

  return request();
};

export const changeReservationDayStatus = (id, status) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.reservations
        .changeReservationDayStatus(id, status)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.CHANGE_RESERVATION_DAY_STATUS_FAILED,
              reject: actionTypes.CHANGE_RESERVATION_DAY_STATUS_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () =>
    action(actionTypes.CHANGE_RESERVATION_DAY_STATUS_LOADING);
  const success = res =>
    action(actionTypes.CHANGE_RESERVATION_DAY_STATUS_SUCCESS, res);

  return request();
};

export const fetchAllReservationHours = (query, cafeDateId) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.reservations
        .fetchAllReservationHours(query, cafeDateId)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_RESERVATION_HOURS_FAILED,
              reject: actionTypes.FETCH_RESERVATION_HOURS_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_RESERVATION_HOURS_LOADING);
  const success = res =>
    action(actionTypes.FETCH_RESERVATION_HOURS_SUCCESS, res);

  return request();
};

export const insertNewReservationDay = reservationObject => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.reservations
        .insertNewReservationDay(reservationObject)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.INSERT_NEW_RESERVATION_DAY_FAILED,
              reject: actionTypes.INSERT_NEW_RESERVATION_DAY_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.INSERT_NEW_RESERVATION_DAY_LOADING);
  const success = res =>
    action(actionTypes.INSERT_NEW_RESERVATION_DAY_SUCCESS, res);

  return request();
};

export const updateReservationDay = reservationObject => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.reservations
        .updateReservationDay(reservationObject)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.UPDATE_RESERVATION_DAY_FAILED,
              reject: actionTypes.UPDATE_RESERVATION_DAY_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.UPDATE_RESERVATION_DAY_LOADING);
  const success = res =>
    action(actionTypes.UPDATE_RESERVATION_DAY_SUCCESS, res);

  return request();
};

export const updateReservationHour = reservationObject => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.reservations
        .updateReservationHour(reservationObject)
        .then(res => {
          const { reservationHoursList } = store.getState().reserveTimesReducer;
          const index = reservationHoursList.findIndex(
            item => item.id === reservationObject.id,
          );
          const updateList = [...reservationHoursList];
          updateList[index] = {
            ...updateList[index],
            status: reservationObject.status,
          };
          dispatch(success(updateList));
        })
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.UPDATE_RESERVATION_HOUR_FAILED,
              reject: actionTypes.UPDATE_RESERVATION_HOUR_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.UPDATE_RESERVATION_HOUR_LOADING);
  const success = res =>
    action(actionTypes.UPDATE_RESERVATION_HOUR_SUCCESS, res);

  return request();
};

export const updateReservationHourStatusAtSchematics = reservationObject => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.reservations
        .updateReservationHourStatusAtSchematics(reservationObject)
        .then(res => {
          const {
            incomingSchematicReservationsList,
          } = store.getState().reservationsReducer;
          let tableIndex = '';
          let updateTableList =[]
          incomingSchematicReservationsList.map(
            item =>
              {item.fromTime === reservationObject.fromTime &&
              (tableIndex = item.tables.findIndex(
                table => table.tableTimeId === reservationObject.id,
              ),
              (updateTableList = [...item.tables]),
              (updateTableList[tableIndex] = {
                ...updateTableList[tableIndex],
                tableTimeStatus: reservationObject.status,
              })
              )}
          );
          dispatch(success(updateTableList));
        })
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.UPDATE_RESERVATION_HOUR_FAILED,
              reject: actionTypes.UPDATE_RESERVATION_HOUR_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.UPDATE_RESERVATION_HOUR_LOADING);
  const success = res =>
    action(actionTypes.UPDATE_RESERVATION_HOUR_SUCCESS, res);

  return request();
};

export const insertNewReservationHour = reservationObject => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.reservations
        .insertNewReservationHour(reservationObject)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.INSERT_NEW_RESERVATION_HOUR_FAILED,
              reject: actionTypes.INSERT_NEW_RESERVATION_HOUR_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.INSERT_NEW_RESERVATION_HOUR_LOADING);
  const success = res =>
    action(actionTypes.INSERT_NEW_RESERVATION_HOUR_SUCCESS, res);

  return request();
};

export const deleteReservationDay = id => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.reservations
        .deleteReservationDay(id)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.DELETE_RESERVATION_DAY_FAILED,
              reject: actionTypes.DELETE_RESERVATION_DAY_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.DELETE_RESERVATION_DAY_LOADING);
  const success = res =>
    action(actionTypes.DELETE_RESERVATION_DAY_SUCCESS, res);

  return request();
};

export const deleteReservationHour = id => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.reservations
        .deleteReservationHour(id)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.DELETE_RESERVATION_HOUR_FAILED,
              reject: actionTypes.DELETE_RESERVATION_HOUR_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.DELETE_RESERVATION_HOUR_LOADING);
  const success = res =>
    action(actionTypes.DELETE_RESERVATION_HOUR_SUCCESS, res);

  return request();
};
